function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("g", null, React.createElement("path", {
  fill: "#27AE60",
  d: "M228,136.8c0,8.396-6.805,15.2-15.2,15.2H15.2C6.805,152,0,145.195,0,136.8V15.2C0,6.805,6.805,0,15.2,0 h197.6c8.396,0,15.2,6.805,15.2,15.2V136.8z"
}));

var _ref3 = React.createElement("path", {
  fill: "#2ECC71",
  d: "M212.229,10H43.869l66.897,132h101.462c3.314,0,5.771-2.281,5.771-5.595v-120 C218,13.091,215.543,10,212.229,10z"
});

var _ref4 = React.createElement("g", null, React.createElement("path", {
  fill: "#1C7A42",
  d: "M46.177,55.576c0.941,0,1.81,0.507,1.81,1.81s-0.869,1.81-1.81,1.81H30.109V31.038h16.068 c0.941,0,1.81,0.507,1.81,1.81c0,1.303-0.869,1.81-1.81,1.81h-12.45v8.65h5.32c0.941,0,1.81,0.507,1.81,1.81 c0,1.303-0.869,1.81-1.81,1.81h-5.32v8.649H46.177z"
}), React.createElement("path", {
  fill: "#1C7A42",
  d: "M64.751,42.945c1.484,0,2.171,0.579,2.171,2.208c0,1.628-0.688,2.208-2.171,2.208h-8.469 c-1.483,0-2.171-0.579-2.171-2.208c0-1.629,0.688-2.208,2.171-2.208H64.751z"
}), React.createElement("path", {
  fill: "#1C7A42",
  d: "M87.053,59.195c-2.714,0-4.271-1.086-5.429-3.438l-3.33-6.731c-0.615-1.23-0.977-2.389-0.977-3.8 c0-1.592,0.29-2.569,1.013-4.017l3.329-6.695c1.231-2.497,2.787-3.475,5.573-3.475h6.153c0.795,0,1.81,0.435,1.81,1.81 c0,1.303-0.977,1.81-1.81,1.81h-6.044c-1.557,0-1.81,0.146-2.497,1.521l-3.149,6.296c-0.47,0.977-0.76,1.628-0.76,2.75 c0,1.013,0.326,1.629,0.76,2.497l3.076,6.262c0.724,1.483,1.086,1.592,2.714,1.592h5.899c0.795,0,1.81,0.434,1.81,1.81 c0,1.303-0.977,1.81-1.81,1.81H87.053z"
}), React.createElement("path", {
  fill: "#1C7A42",
  d: "M106.749,46.926v10.459c0,1.158-0.507,1.81-1.81,1.81s-1.809-0.651-1.809-1.81V32.848 c0-1.158,0.506-1.81,1.809-1.81s1.81,0.651,1.81,1.81v10.459h10.641V32.848c0-1.158,0.506-1.81,1.81-1.81 c1.303,0,1.81,0.651,1.81,1.81v24.538c0,1.158-0.507,1.81-1.81,1.81c-1.304,0-1.81-0.651-1.81-1.81V46.926H106.749z"
}), React.createElement("path", {
  fill: "#1C7A42",
  d: "M146.785,55.576c0.939,0,1.81,0.507,1.81,1.81s-0.87,1.81-1.81,1.81h-16.069V31.038h16.069 c0.939,0,1.81,0.507,1.81,1.81c0,1.303-0.87,1.81-1.81,1.81h-12.451v8.65h5.32c0.94,0,1.811,0.507,1.811,1.81 c0,1.303-0.87,1.81-1.811,1.81h-5.32v8.649H146.785z"
}), React.createElement("path", {
  fill: "#1C7A42",
  d: "M163.936,59.195c-2.715,0-4.27-1.086-5.429-3.438l-3.33-6.731c-0.615-1.23-0.978-2.389-0.978-3.8 c0-1.592,0.29-2.569,1.016-4.017l3.329-6.695c1.229-2.497,2.785-3.475,5.572-3.475h6.152c0.796,0,1.81,0.435,1.81,1.81 c0,1.303-0.978,1.81-1.81,1.81h-6.044c-1.555,0-1.809,0.146-2.496,1.521l-3.149,6.296c-0.471,0.977-0.76,1.628-0.76,2.75 c0,1.013,0.325,1.629,0.76,2.497l3.076,6.262c0.724,1.483,1.086,1.592,2.714,1.592h5.899c0.796,0,1.81,0.434,1.81,1.81 c0,1.303-0.978,1.81-1.81,1.81H163.936z"
}), React.createElement("path", {
  fill: "#1C7A42",
  d: "M180.013,32.848c0-1.158,0.507-1.81,1.81-1.81s1.81,0.651,1.81,1.81v8.324l11.037-9.373 c0.436-0.362,0.905-0.724,1.484-0.724c1.05,0,1.737,0.868,1.737,1.882c0,0.615-0.397,1.122-0.832,1.52l-12.486,10.64l12.413,10.64 c0.472,0.398,0.905,0.905,0.905,1.556c0,1.013-0.688,1.882-1.737,1.882c-0.76,0-1.375-0.651-1.954-1.086l-10.567-9.083v8.36 c0,1.158-0.507,1.81-1.81,1.81s-1.81-0.651-1.81-1.81V32.848z"
}));

var _ref5 = React.createElement("rect", {
  x: 30.109,
  y: 109,
  fill: "#1C7A42",
  width: 101.391,
  height: 10
});

var _ref6 = React.createElement("rect", {
  x: 159,
  y: 109,
  fill: "#1C7A42",
  width: 38.891,
  height: 10
});

var _ref7 = React.createElement("rect", {
  x: 30.109,
  y: 83.787,
  fill: "#1C7A42",
  width: 101.391,
  height: 10
});

var _ref8 = React.createElement("rect", {
  x: 159,
  y: 83.787,
  fill: "#1C7A42",
  width: 38.891,
  height: 10
});

var _ref9 = React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M46.177,52.774c0.941,0,1.81,0.507,1.81,1.81s-0.869,1.81-1.81,1.81H30.109V28.236h16.068 c0.941,0,1.81,0.507,1.81,1.81c0,1.303-0.869,1.81-1.81,1.81h-12.45v8.65h5.32c0.941,0,1.81,0.507,1.81,1.81 c0,1.303-0.869,1.81-1.81,1.81h-5.32v8.649H46.177z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M64.751,40.144c1.484,0,2.171,0.579,2.171,2.208c0,1.628-0.688,2.208-2.171,2.208h-8.469 c-1.483,0-2.171-0.579-2.171-2.208c0-1.629,0.688-2.208,2.171-2.208H64.751z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M87.053,56.393c-2.714,0-4.271-1.086-5.429-3.438l-3.33-6.731c-0.615-1.23-0.977-2.389-0.977-3.8 c0-1.592,0.29-2.569,1.013-4.017l3.329-6.695c1.231-2.497,2.787-3.475,5.573-3.475h6.153c0.795,0,1.81,0.435,1.81,1.81 c0,1.303-0.977,1.81-1.81,1.81h-6.044c-1.557,0-1.81,0.146-2.497,1.521l-3.149,6.296c-0.47,0.977-0.76,1.628-0.76,2.75 c0,1.013,0.326,1.629,0.76,2.497l3.076,6.262c0.724,1.483,1.086,1.592,2.714,1.592h5.899c0.795,0,1.81,0.434,1.81,1.81 c0,1.303-0.977,1.81-1.81,1.81H87.053z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M106.749,44.125v10.459c0,1.158-0.507,1.81-1.81,1.81s-1.809-0.651-1.809-1.81V30.046 c0-1.158,0.506-1.81,1.809-1.81s1.81,0.651,1.81,1.81v10.459h10.641V30.046c0-1.158,0.506-1.81,1.81-1.81 c1.303,0,1.81,0.651,1.81,1.81v24.538c0,1.158-0.507,1.81-1.81,1.81c-1.304,0-1.81-0.651-1.81-1.81V44.125H106.749z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M146.785,52.774c0.939,0,1.81,0.507,1.81,1.81s-0.87,1.81-1.81,1.81h-16.069V28.236h16.069 c0.939,0,1.81,0.507,1.81,1.81c0,1.303-0.87,1.81-1.81,1.81h-12.451v8.65h5.32c0.94,0,1.811,0.507,1.811,1.81 c0,1.303-0.87,1.81-1.811,1.81h-5.32v8.649H146.785z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M163.936,56.393c-2.715,0-4.27-1.086-5.429-3.438l-3.33-6.731c-0.615-1.23-0.978-2.389-0.978-3.8 c0-1.592,0.29-2.569,1.016-4.017l3.329-6.695c1.229-2.497,2.785-3.475,5.572-3.475h6.152c0.796,0,1.81,0.435,1.81,1.81 c0,1.303-0.978,1.81-1.81,1.81h-6.044c-1.555,0-1.809,0.146-2.496,1.521l-3.149,6.296c-0.471,0.977-0.76,1.628-0.76,2.75 c0,1.013,0.325,1.629,0.76,2.497l3.076,6.262c0.724,1.483,1.086,1.592,2.714,1.592h5.899c0.796,0,1.81,0.434,1.81,1.81 c0,1.303-0.978,1.81-1.81,1.81H163.936z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M180.013,30.046c0-1.158,0.507-1.81,1.81-1.81s1.81,0.651,1.81,1.81v8.324l11.037-9.373 c0.436-0.362,0.905-0.724,1.484-0.724c1.05,0,1.737,0.868,1.737,1.882c0,0.615-0.397,1.122-0.832,1.52l-12.486,10.64l12.413,10.64 c0.472,0.398,0.905,0.905,0.905,1.556c0,1.013-0.688,1.882-1.737,1.882c-0.76,0-1.375-0.651-1.954-1.086l-10.567-9.083v8.36 c0,1.158-0.507,1.81-1.81,1.81s-1.81-0.651-1.81-1.81V30.046z"
}));

var SvgPayEcheck = function SvgPayEcheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "228px",
    height: "152px",
    viewBox: "0 0 228 152",
    preserveAspectRatio: "xMinYMin meet",
    enableBackground: "new 0 0 228 152",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPayEcheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pay-echeck.7655b006.svg";
export { ForwardRef as ReactComponent };